import { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

import {
  Home,
  List,
  FormatListNumbered,
  Report,
  SettingsAccessibility,
  Logout,
  Settings,
  Cancel,
  Map,
  Handshake,
  AddBusiness,
  HowToReg,
  ListAlt,
 
} from "@mui/icons-material";

import RootLayout from "../RootLayout";

const invsetorAftercareMenuItems = theme => [
  {
    key: "home",
    to: "/",
    title: "Home",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "white" }}>
        <Home />
      </Box>
    ),
  },
  {
    key: "investorList",
    to: "/investorList",
    title: "Investor List",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <List />
      </Box>
    ),
  },
  {
    key: "viewMapByCategory",
    to: "/viewMapByCategory",
    title: "Map By Category",
    iconClass: <Map />,
  },
  {
    key: "GROUP",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <ListAlt />
      </Box>
    ),
    title: "List",
    detail: [
      {
        key: "agreementList",
        to: "/agreementList",
        title: "Agreements",
        iconClass: (
          <Box>
            <List />
          </Box>
        ),
      },
      {
        key: "investorList",
        to: "/investorList",
        title: "Investors",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <List />
          </Box>
        ),
      },
      {
        key: "propertyList",
        to: "/parcelList",
        title: "Parcels",
        iconClass: (
          <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
            <FormatListNumbered />
          </Box>
        ),
      },
    ],
  },
   // ******** The following group is added for approval 
  {
    key: "GROUP",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <AddBusiness />
      </Box>
    ),
    title: "Approval",
    detail: [
      
      {
        // key: "verifyAggrement",to: "/verifyAggrement", title: "Agreement",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Handshake /></Box>),  
           key: "approveAggrement",to: "/approveAggrement", title: "Agreement",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Handshake /></Box>),  
	 
      },
      {
        key: "approveRenewalRequest",to: "/approveRenewalRequest", title: "Renewed Agreement",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Handshake /></Box>),
      },
      {
        key: "approveTerminationRequest",to: "/approveTerminationRequest", title: "Termination",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Cancel /></Box>),
      },
      
      {
        key: "ApprovalInverstorActivity",to: "/ApprovalInverstorActivity", title: "Investor Activity",iconClass: (<Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}><Cancel /></Box>),
      },
    ],
},
//*********** */
{
  key: "GROUP",
  iconClass: (
    <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
      <ListAlt />
    </Box>
  ),
  title: "Report",
  detail: [
    
    {
      key: "investorList",
      to: "/investorReport",
      title: "Investors",
      iconClass: (
        <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
          <List />
        </Box>
      ),
    },
    {
      key: "employment",
      to: "/employment",
      title: "Employement",
      iconClass: (
        <Box>
          <List />
        </Box>
      ),
    },
    {
      key: "tradereport",
      to: "/tradereport",
      title: "Trade",
      iconClass: (
        <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
          <FormatListNumbered />
        </Box>
      ),
    },
    // {
    //   key: "InvAfterCareReport",
    //   to: "/InvAfterCareReport",
    //   title: "Report",
    //   iconClass: (
    //     <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
    //       <Report />
    //     </Box>
    //   ),
    // },
    {
      key: "arrear",
      to: "/arrear",
      title: "Arrear Report",
      iconClass: (
        <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
          <Report />
        </Box>
      ),
    },
  ],
},
  {
    key: "invAftercareSettings",
    to: "/invAftercareSettings",
    title: "Settings",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <Settings />
      </Box>
    ),
  },
  {
    key: "myPreference",
    to: "/myPreference",
    title: "Preferences",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <SettingsAccessibility />
      </Box>
    ),
  },
  {
    key: "logout",
    to: "/logout",
    title: "Logout",
    iconClass: (
      <Box sx={{ color: theme.palette.mode === "dark" ? "white" : "inherit" }}>
        <Logout />
      </Box>
    ),
  },
];

export default function OperationAndManagementHeadLayout() {
  const theme = useTheme();
  useEffect(() => {
    console.log(theme.palette);
  }, [theme.palette]);
  const [open, setOpen] = useState(true);
  const [showProfile, setShowProfile] = useState(true);

  return (
    <RootLayout
      department="Operations"
      open={open}
      setOpen={setOpen}
      showProfile={showProfile}
      setShowProfile={setShowProfile}
      menuList={invsetorAftercareMenuItems(theme)}
    />
  );
}
